export class DocumentResultDto {
  fileName: string;
  fileUrl: string;
  size: number;
  effectiveDate: Date;
  description: string;
}
